import * as api from './StatisticsApi';
import * as type from './StatisticsType';

export const getPatientStatistics =
    (namespace, params, service = api.getPatientStatistics) =>
    async (dispatch) => {
        dispatch({
            type: type.GET_PATIENT_STATISTICS.REQUEST
        });
        return await service(namespace, params).then((response) => {
            dispatch({
                type: type.GET_PATIENT_STATISTICS.SUCCESS,
                payload: { data: response.data, start: params.start, end: params.end }
            });
        });
    };

export const getFormStatistics =
    (namespace, params, service = api.getFormStatistics) =>
    async (dispatch) => {
        dispatch({
            type: type.GET_FORM_STATISTICS.REQUEST
        });
        return await service(namespace, params).then((response) => {
            dispatch({
                type: type.GET_FORM_STATISTICS.SUCCESS,
                payload: { data: response.data, start: params.start, end: params.end }
            });
        });
    };
